module.exports = __webpack_public_path__ + "img/street-macro.png";